import React, { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';

type SubTabItemType = {
	eventKey: string;
	title: string;
	content: React.ReactNode;
	shouldBeVisible?: boolean;
};

interface SubTabsProps {
	subNavItems: SubTabItemType[];
	onValueChangeCallback?: (key: string) => void;
	externalKey?: string;
}

const SubTabs: React.FC<SubTabsProps> = ({ subNavItems, onValueChangeCallback, externalKey }) => {
	const [activeKey, setActiveKey] = useState(externalKey || subNavItems[0].eventKey);
	return (
		<Tabs
			variant="pills"
			activeKey={activeKey}
			onSelect={(key) => {
				setActiveKey(key);
				onValueChangeCallback && onValueChangeCallback(key);
			}}
			style={{
				marginBottom: '3rem',
			}}
		>
			{subNavItems.map((subNavItem) => {
				if (subNavItem.shouldBeVisible === false) return null;
				return (
					<Tab eventKey={subNavItem.eventKey} title={subNavItem.title} key={subNavItem.eventKey}>
						{subNavItem.eventKey === activeKey ? subNavItem.content : null}
					</Tab>
				);
			})}
		</Tabs>
	);
};

export default SubTabs;
